import React, { FC, SVGAttributes } from "react"

const ArrowDown: FC<SVGAttributes<SVGElement>> = ({ ...props }) => {
    return <svg
        fill="none"
        stroke="currentColor"
        viewBox="0 0 10 16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path fillRule="evenodd" clipRule="evenodd" d="M5.00034 1C5.27649 1 5.50034 1.22386 5.50034 1.5L5.50034 13.293L8.64634 10.146C8.84185 9.95049 9.15884 9.95049 9.35434 10.146C9.54985 10.3415 9.54985 10.6585 9.35434 10.854L5.35434 14.854C5.26054 14.948 5.13317 15.0009 5.00034 15.0009C4.86752 15.0009 4.74015 14.948 4.64635 14.854L0.646345 10.854C0.450836 10.6585 0.450836 10.3415 0.646345 10.146C0.841854 9.95049 1.15884 9.95049 1.35435 10.146L4.50034 13.293L4.50034 1.5C4.50034 1.22386 4.7242 1 5.00034 1Z" />
    </svg>
}

export default ArrowDown
